import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// FR
import frCommon from './locales/fr/common.json';
import frNavigation from './locales/fr/navigation.json';
import frForms from './locales/fr/forms.json';
import frErrors from './locales/fr/errors.json';
import frComponents from './locales/fr/components.json';
import frPages from './locales/fr/pages.json';

// EN
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enForms from './locales/en/forms.json';
import enErrors from './locales/en/errors.json';
import enComponents from './locales/en/components.json';
import enPages from './locales/en/pages.json';

// ES
import esCommon from './locales/es/common.json';
import esNavigation from './locales/es/navigation.json';
import esForms from './locales/es/forms.json';
import esErrors from './locales/es/errors.json';
import esComponents from './locales/es/components.json';
import esPages from './locales/es/pages.json';

export const SUPPORTED_LANGS = ['fr', 'en', 'es'];
export const DEFAULT_LANG = 'fr';

// Storage keys — exposed for non-React consumers (analytics, language switcher).
export const LANG_STORAGE_KEY = 'preferredLanguage';
export const ANALYTICS_CONSENT_KEY = 'cookie_consent_analytics';

const NAMESPACES = ['common', 'navigation', 'forms', 'errors', 'components', 'pages'];

const resources = {
  fr: {
    common: frCommon,
    navigation: frNavigation,
    forms: frForms,
    errors: frErrors,
    components: frComponents,
    pages: frPages,
  },
  en: {
    common: enCommon,
    navigation: enNavigation,
    forms: enForms,
    errors: enErrors,
    components: enComponents,
    pages: enPages,
  },
  es: {
    common: esCommon,
    navigation: esNavigation,
    forms: esForms,
    errors: esErrors,
    components: esComponents,
    pages: esPages,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED_LANGS,
    ns: NAMESPACES,
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    // Detection priority: URL path → localStorage → navigator. Path wins so
    // a user on /en/* always reads English, even if their preference says ES.
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupLocalStorage: LANG_STORAGE_KEY,
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },
    react: { useSuspense: false },
  });

export default i18n;
